import { Reveal, SectionHeading } from "../Reveal";

const STEPS = [
  ["Discover", "Understanding your brand, product and vision."],
  ["Concept", "Creating the visual direction and creative idea."],
  ["Create", "Bringing the concept to life through imagery and film."],
  ["Deliver", "Providing beautifully finished creative assets."],
];

export const Process = () => (
  <section data-testid="process-section" className="mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-40">
    <SectionHeading eyebrow="Our Approach" title={<>From Vision <span className="italic">to Visual.</span></>} />
    <ol className="relative mt-20 grid gap-0 border-l border-line pl-8 md:grid-cols-4 md:border-l-0 md:border-t md:pl-0">
      {STEPS.map(([title, text], i) => (
        <Reveal as="li" key={title} delay={i * 0.12} className="relative pb-14 last:pb-0 md:pb-0 md:pr-10 md:pt-12">
          <span className="absolute -left-[37px] top-1 h-[9px] w-[9px] rotate-45 border border-wine bg-ivory md:-top-[5px] md:left-0" />
          <span className="font-serif text-5xl font-light text-champagne md:text-6xl">0{i + 1}</span>
          <h3 className="mt-4 font-serif text-3xl text-wine" data-testid={`process-step-${i + 1}`}>{title}</h3>
          <p className="mt-3 max-w-[16rem] text-sm leading-relaxed text-charcoal/80 md:text-base">{text}</p>
        </Reveal>
      ))}
    </ol>
  </section>
);
